import { JitsiTrackStreamingStatus } from '../../../react/features/base/lib-jitsi-meet';
import { VIDEO_TYPE } from '../../../react/features/base/media/constants';
import MiddlewareRegistry from '../../../react/features/base/redux/MiddlewareRegistry';
import { TRACK_UPDATED } from '../../../react/features/base/tracks/actionTypes';
import { updateUserInTileViewList } from './actions';
import { isPipPlaying, isTileViewEnabled } from './function';
const streamingStatusByParticipantId = {};
/**
 * Middleware which intercepts lib-jitsi-meet initialization and conference join in order init the
 * rtcstats-client.
 *
 * @param {Store} store - The redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register((store) => (next) => (action) => {
    const { getState, dispatch } = store;
    const state = getState();
    switch (action.type) {
        case TRACK_UPDATED: {
            const { tileViewList } = state['wildix/features/PiP'];
            const { jitsiTrack, streamingStatus } = action.track;
            if (!isPipPlaying(state) || jitsiTrack.videoType !== VIDEO_TYPE.CAMERA) {
                break;
            }
            const userIdByTrack = jitsiTrack.getParticipantId();
            const prevStreamingStatus = streamingStatusByParticipantId[userIdByTrack];
            if (streamingStatus && prevStreamingStatus !== streamingStatus) {
                if (JitsiTrackStreamingStatus.INACTIVE === streamingStatus) {
                    if (isTileViewEnabled(state) && tileViewList?.[userIdByTrack]) {
                        dispatch(updateUserInTileViewList(userIdByTrack, {
                            isVideoPlaying: false,
                            videoTrack: jitsiTrack,
                            videoTrackID: userIdByTrack
                        }));
                    }
                    streamingStatusByParticipantId[userIdByTrack] = streamingStatus;
                }
                else if (streamingStatus === JitsiTrackStreamingStatus.ACTIVE) {
                    if (isTileViewEnabled(state) && tileViewList?.[userIdByTrack]) {
                        dispatch(updateUserInTileViewList(userIdByTrack, {
                            isVideoPlaying: !jitsiTrack.isMuted(),
                            videoTrack: jitsiTrack,
                            videoTrackID: userIdByTrack
                        }));
                    }
                    streamingStatusByParticipantId[userIdByTrack] = streamingStatus;
                }
            }
            break;
        }
    }
    return next(action);
});
